import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en.json';
import translationFI from './locales/fi.json';

const resources = {
  en: {
    translation: translationEN
  },
  fi: {
    translation: translationFI
  }
};

i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n to react-i18next
  .init({
    resources,
    fallbackLng: 'fi', // Default to Finnish when detection fails
    lng: localStorage.getItem('language') || 'fi', // Prefer saved language, otherwise Finnish
    interpolation: {
      escapeValue: false // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    }
  });

export default i18n;
